import { createSlice } from '@reduxjs/toolkit';

import { setActiveCards } from './setActiveCards';

import { CardsState } from '../../types';

import { CARDS_STATE } from '../../constants';

const initialState: CardsState = {
  activeCards: {}
}

export const driversSlice = createSlice({
  name: CARDS_STATE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    setActiveCards(builder);
  }
});

export const cardsActions = driversSlice.actions;
export const cardsReducer = driversSlice.reducer;